function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5303 7.53033C20.8232 7.23744 20.8232 6.76256 20.5303 6.46967C20.2374 6.17678 19.7626 6.17678 19.4697 6.46967L20.5303 7.53033ZM9.00004 18L8.46972 18.5303C8.76261 18.8232 9.23748 18.8232 9.53037 18.5303L9.00004 18ZM4.53026 12.4697C4.23736 12.1768 3.76249 12.1768 3.4696 12.4697C3.17671 12.7626 3.17672 13.2374 3.46962 13.5303L4.53026 12.4697ZM19.4697 6.46967L8.46971 17.4696L9.53037 18.5303L20.5303 7.53033L19.4697 6.46967ZM3.46962 13.5303L8.46972 18.5303L9.53036 17.4696L4.53026 12.4697L3.46962 13.5303Z",
  fill: "#001A72"
});

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.170c5784.svg";
export { ForwardRef as ReactComponent };